module.exports = __webpack_public_path__ + "img/img (26).216a084d.jpg";